import { defineMessages } from 'react-intl-next';

export const messages: {
	refinedUnsplashSearchPlaceholderText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	unsplashLoadMoreText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	unsplashSearchAriaLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	refinedUnsplashSearchPlaceholderText: {
		id: 'company-hub.company-hub-common.refined.unsplash.search.placeholder',
		defaultMessage: 'Browse Unsplash',
		description: 'Visible placeholder text for the text-field used to search for unsplash images',
	},
	unsplashLoadMoreText: {
		id: 'company-hub.company-hub-common.unsplash.search.load.more.unsplash.photos',
		defaultMessage: 'Load more',
		description: 'Text in button user can click to load more Unsplash images',
	},
	unsplashSearchAriaLabel: {
		id: 'company-hub.company-hub-common.unsplash.search.aria-label',
		defaultMessage: 'Search header images',
		description:
			'Accessible label for the search input field used to search for Unsplash header images',
	},
});
